<div class="link-sound" [ngClass]="{'tap-top': showScroll}" (click)="onActivate()">
  <div><i class="fa fa-angle-double-up"></i></div>
</div>